import { Stack } from "@mui/material";
import StyledFormLabel from "./StyledFormLabel";
import React from "react";
import StyledFormHelperText from "../UI/StyledFormHelperText";
import { FormControl } from "@mui/material";
import { styled } from "@mui/system";

const StyledControl = styled(FormControl)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  minWidth: 80,
  gap: 6,
}));


const StyledFormControl = React.forwardRef(
  (
    {
      label = "",
      showLabel = true,
      helperText = null,
      error = false,
      id = null,
      sx={},
      children,
    },
    ref
  ) => (
    <StyledControl ref={ref} sx={{ ...sx }}>
      {label && showLabel ? (
        <StyledFormLabel htmlFor={id}>
          <Stack direction={"row"} sx={{ gap: "12px" }}>
            {label}
          </Stack>
        </StyledFormLabel>
      ) : null}
      {children}
      {helperText ? (
        <StyledFormHelperText error={error} id={`${id}-helper-text`}>
          {helperText}
        </StyledFormHelperText>
      ) : null}
    </StyledControl>
  )
);

StyledFormControl.displayName = "StyledFormControl";
export default React.memo(StyledFormControl);
